import { render, staticRenderFns } from "./fmWhatsapp.vue?vue&type=template&id=08b933ba"
import script from "./fmWhatsapp.vue?vue&type=script&lang=js"
export * from "./fmWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports